import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "container tw"
};
const _hoisted_2 = {
  key: 1,
  class: "container overflow-hidden tw color-unset lineheight-unset"
};
const _hoisted_3 = {
  class: "import-layout pb-28 h-full overflow-auto"
};
const _hoisted_4 = {
  class: "left-column"
};
const _hoisted_5 = {
  class: "right-column"
};
const _hoisted_6 = {
  class: "mb-3"
};
const _hoisted_7 = {
  class: "d-flex justify-end mt-4"
};
const _hoisted_8 = {
  class: "mb-4"
};
const _hoisted_9 = {
  class: "d-flex justify-end mt-4"
};
const _hoisted_10 = {
  class: "mt-6"
};
const _hoisted_11 = {
  key: 2,
  class: "pa-5"
};
const _hoisted_12 = {
  key: 3,
  class: "pa-5"
};
import { ref, onMounted } from 'vue';
import RouteService from '@/services/RouteService';
import ExpenseService from '@/services/ExpenseService';
import ExportJsonService from '@/services/ExportJsonService';
import { yyyymmdddash } from '@/services/utils';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import Loader from '@/components/Loader.vue';
import AlertBar from '@/components/AlertBar.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import csv from 'csvtojson';
export default {
  __name: 'EquitracImport',
  props: {
    state: {
      type: Object,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const routeService = new RouteService({
      state: props.state
    });
    const expenseService = new ExpenseService(props.leanLawApi, props.userService, props.alerts);
    const exportJsonService = new ExportJsonService();
    const uploadedObjectArray = ref([]);
    const wasObjectUploaded = ref(false);
    const validationError = ref('');
    const isUploading = ref(false);
    const showPreview = ref(false);
    const doneImporting = ref(false);
    const combinedExpenses = ref([]);
    const completed = ref(0);
    const percentage = ref(0);
    const loading = ref(false);
    const combining = ref(false);
    const combine = ref(true);
    const me = ref(null);
    const csvFile = ref(null);
    const initialLoading = ref(true);
    let filteredMatters = [];

    // Constants for validation
    const altKeys = {
      'clientnickname1': 'id'
    };
    const requiredKeys = ["id", "date", "description", "amount"];

    // Helper function to extract matters array from API response
    const extractMattersArray = response => {
      return Array.isArray(response) ? response : Array.isArray(response.data) ? response.data : Array.isArray(response.matters) ? response.matters : [];
    };
    onMounted(async () => {
      try {
        me.value = await props.userService.getMe();
        const response = await props.leanLawApi.listMatters({
          scope: "all"
        });
        const matterArray = extractMattersArray(response);
        filteredMatters = matterArray.filter(m => Object.hasOwn(m, "reference"));
        initialLoading.value = false;
      } catch (error) {
        console.error('Error initializing component:', error);
        initialLoading.value = false;
      }
    });
    const uploadFile = () => {
      validationError.value = '';

      // Read file from upload field
      const f = csvFile.value.files[0];
      if (!f) {
        validationError.value = "Please select a file to upload.";
        return;
      }
      const r = new FileReader();
      loading.value = true;

      // Fires once the file's text has been read
      r.onloadend = e => {
        try {
          const result = e.target.result;
          if (result === null || result === undefined) {
            throw new Error('Failed to read file content');
          }
          const content = String(result).trim();
          if (!content) {
            throw new Error('File appears to be empty');
          }
          csvToJson(content).then(obj => {
            uploadedObjectArray.value = obj;
            wasObjectUploaded.value = true;
            validationError.value = validate();
            loading.value = false;
          }).catch(error => {
            console.error('Error parsing CSV:', error);
            validationError.value = "Error parsing CSV file. Please check the format.";
            loading.value = false;
          });
        } catch (error) {
          console.error('Error reading file:', error);
          validationError.value = error.message || "Error reading file. Please try again.";
          loading.value = false;
        }
      };
      r.onerror = () => {
        console.error('FileReader error');
        validationError.value = "Error reading file. Please try again.";
        loading.value = false;
      };

      // There are other methods to load as array buffers/binary string/dataURL
      r.readAsText(f);
    };
    const getHeaders = () => {
      return getKeys(uploadedObjectArray.value[0]);
    };

    // Returns keys for header with hidden fields filtered out
    const getKeys = obj => {
      if (!obj) return [];
      return Object.keys(obj).filter(k => k != "$$hashKey");
    };

    // Returns whether a certain cell is invalid given its position in a row
    const isInvalid = (col, row, colIndex, key = null) => {
      if (!col) return true;
      const actualKey = key || Object.keys(row)[colIndex];
      if (!actualKey || typeof actualKey !== 'string') return true;
      const rowName = actualKey.trim().toLowerCase();

      // Check if date is string and it parses
      if (rowName == 'date' && isNaN(new Date(col))) return true;

      // Check if column has a value
      if (typeof col !== 'string' || col.trim().length == 0) return true;

      // Check if id matches with any matter
      if (rowName.toLowerCase() == "id" || altKeys[rowName.toLowerCase()] == 'id') {
        return !filteredMatters.some(m => m.reference == col);
      }
      return false;
    };
    const isValid = (col, row, colIndex, key = null) => {
      if (isInvalid(col, row, colIndex, key)) return false;
      const actualKey = key || Object.keys(row)[colIndex];
      if (!actualKey || typeof actualKey !== 'string') return false;
      const rowName = actualKey.trim().toLowerCase();
      return requiredKeys.includes(altKeys[rowName] || rowName);
    };

    // Returns appropriate CSS class for a cell based on validation
    const getCellClass = (col, row, colIndex, key = null) => {
      if (isInvalid(col, row, colIndex, key)) {
        return 'invalid';
      }
      const actualKey = key || Object.keys(row)[colIndex];
      if (!actualKey || typeof actualKey !== 'string') return '';
      const rowName = actualKey.trim().toLowerCase();
      if (requiredKeys.includes(altKeys[rowName] || rowName)) {
        return 'success';
      }
      return '';
    };
    const getCellStyle = (col, row, colIndex, key = null) => {
      if (isInvalid(col, row, colIndex, key)) {
        return {
          backgroundColor: '#f2dede',
          color: '#a94442'
        };
      }
      const actualKey = key || Object.keys(row)[colIndex];
      if (!actualKey || typeof actualKey !== 'string') return {};
      const rowName = actualKey.trim().toLowerCase();
      if (requiredKeys.includes(altKeys[rowName] || rowName)) {
        return {
          backgroundColor: '#dff0d8',
          color: '#3c763d'
        };
      }
      return {};
    };
    const validate = () => {
      let keysValid = true;
      // marks unused columns as ignored and check that required columns are there
      uploadedObjectArray.value.forEach(line => {
        const keys = Object.keys(line).map(key => {
          const mapped = (altKeys[key.toLowerCase()] || key).toLowerCase();
          const included = requiredKeys.includes(mapped);
          return {
            key,
            mapped,
            ignore: !included
          };
        });
        const hasRequired = requiredKeys.every(req => keys.find(k => k.mapped === req));
        if (!hasRequired) {
          keysValid = false;
        }
      });
      if (!keysValid) {
        return `You're missing the required columns. Be sure that your csv includes a header row at the top of the file, and that there are no empty fields.`;
      }
      const keysNotNull = uploadedObjectArray.value.every(uo => {
        const keys = Object.keys(uo);
        return keys.every(k => uo[k] != null && uo[k] !== "");
      });
      if (!keysNotNull) {
        return `You're missing at least one field in your import. Double check that your data is complete.`;
      }
      const idsMatch = uploadedObjectArray.value.every(uo => {
        const hasMatch = filteredMatters.some(m => m.reference === uo.id || m.reference === uo.ClientNickname1);
        return hasMatch;
      });
      if (!idsMatch) {
        return `At least one of the expense ids doesn't correspond to an existing matter. See below for details.`;
      }

      // Used when checking for disabled submit
      return '';
    };

    // Returns promise with object
    const csvToJson = async src => {
      return csv().fromString(src);
    };
    const combineChanged = combineValue => {
      combining.value = true;
      processExpenses(combineValue);
      combining.value = false;
    };
    const next = () => {
      combine.value = true;
      processExpenses(true);
      showPreview.value = true;
    };
    const processExpenses = combineValue => {
      if (!combineValue) {
        combinedExpenses.value = uploadedObjectArray.value.map(row => cleanExpense(row));
        return;
      }
      combinedExpenses.value = uploadedObjectArray.value.reduce((accum, row) => {
        const clean = cleanExpense(row);
        const dateStr = yyyymmdddash(clean.date).substring(0, 7);
        clean.group = `${dateStr}|${clean.matter.id}`;
        let idx = accum.findIndex(r => r.group === clean.group);
        if (idx === -1) {
          accum.push(clean);
          idx = accum.length - 1;
        } else {
          const addto = accum[idx];
          addto.amount += clean.amount;
          if (addto.date < clean.date) {
            addto.date = clean.date;
          }
          if (addto.description.indexOf(clean.description) === -1) {
            addto.description = `${addto.description}; ${clean.description}`;
          }
        }
        return accum;
      }, []);

      // Add month to expenses
      combinedExpenses.value.forEach(e => {
        const month = e.date.toLocaleString('en-us', {
          month: 'long'
        });
        // We are hardcoding the description here as opposed to taking the descriptions
        // that came along with the import. This is for Sinas. If other clients need
        // this we are likely to want to make this configurable
        // such that either we use the imported descriptions or we hard-code it based
        // on a company setting.
        e.description = `${month} Photocopies, Facsimiles, Postage, and Long Distance`;
      });
    };
    const cleanExpense = row => {
      const matter = filteredMatters.find(f => f.reference === row.id || f.reference === row.ClientNickname1);

      // Add label property to matter for consistent display formatting
      if (matter && !matter.label) {
        matter.label = matter.reference && matter.reference.trim() ? `${matter.reference}- ${matter.name}` : matter.name;
      }
      return {
        date: new Date(row.date || row.Date),
        amount: +(row.amount || row.Amount),
        description: row.description || row.Description,
        matter: matter
      };
    };

    // Begin the import process after the data has been consolidated
    const importExpenses = () => {
      isUploading.value = true;
      const throttleTime = 50;

      // Execute create sequentially with a throttle
      combinedExpenses.value.reduce((prev, expense) => {
        return prev.then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              expenseService.create(expense.matter, expense, true).then(e => {
                completed.value++;
                percentage.value = 100 * completed.value / combinedExpenses.value.length;
                resolve();
              }).catch(error => {
                console.error('Error creating expense:', error);
                reject(error);
              });
            }, throttleTime);
          });
        });
      }, Promise.resolve()).then(() => {
        doneImporting.value = true;
      }).catch(error => {
        console.error('Error during import:', error);
        props.alerts.error('An error occurred during import. Please check the console for details.');
        isUploading.value = false;
      });
    };
    const finish = () => {
      routeService.go("expenses");
    };
    const exportMatters = () => {
      let exp = [];
      props.leanLawApi.listMatters({
        scope: "all"
      }).then(response => {
        const matters = extractMattersArray(response);
        matters.forEach(m => {
          exp.push({
            name: m.reference || '',
            description: m.name
          });
        });

        // Dedup
        exp = exp.filter((matter, index, self) => index === self.findIndex(e => e.name == matter.name && e.description == matter.description));
        exportJsonService.downloadCsv(exp, 'leanlaw-export', false); // false = no header row
      }).catch(error => {
        console.error('Error exporting matters:', error);
        props.alerts.error('Failed to export matters. Please try again.');
      });
    };

    // Utility functions for formatting
    const formatDate = date => {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    };
    const formatAmount = amount => {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    };
    return (_ctx, _cache) => {
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_table = _resolveComponent("v-table");
      const _component_v_progress_linear = _resolveComponent("v-progress-linear");
      return initialLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Loader, {
        what: "expense import data"
      })])) : me.value && !me.value.company?.settings?.requireExpenseUser ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_card, {
        class: "pa-4"
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("h4", {
          class: "mb-3"
        }, "Select csv file for import:", -1)), _createElementVNode("input", {
          type: "file",
          name: "csvfile",
          id: "csvfile",
          ref_key: "csvFile",
          ref: csvFile,
          class: "mb-3"
        }, null, 512), _createVNode(LlSecondaryButton, {
          color: "primary",
          disabled: loading.value,
          onClick: _cache[0] || (_cache[0] = $event => uploadFile()),
          class: "mb-4"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Prepare for Import ", -1)]))]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_v_divider, {
          class: "my-4"
        }), _cache[10] || (_cache[10] = _createElementVNode("p", null, "Or, to export your matters for use in Equitrac (or similar) machines", -1)), _createVNode(LlSecondaryButton, {
          color: "primary",
          onClick: _cache[1] || (_cache[1] = $event => exportMatters())
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Export Matters ", -1)]))]),
          _: 1
        })]),
        _: 1
      })], 512), [[_vShow, !isUploading.value]]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", null, [_createVNode(Loader, {
        what: "import data"
      })], 512), [[_vShow, loading.value]]), _withDirectives(_createVNode(_component_v_card, {
        class: "pa-4"
      }, {
        default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("h3", {
          class: "mb-3"
        }, "Expense Data to be Imported", -1)), _cache[14] || (_cache[14] = _createElementVNode("p", {
          class: "mb-3"
        }, "Upload a .csv file with the following columns in the first row. All fields are necessary and case-sensitive:", -1)), _createVNode(_component_v_table, {
          density: "compact",
          class: "mb-3 selectable-table"
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "id"), _createElementVNode("th", null, "Date"), _createElementVNode("th", null, "Description"), _createElementVNode("th", null, "Amount")])], -1)]))]),
          _: 1
        }), _cache[15] || (_cache[15] = _createElementVNode("p", {
          class: "mb-3"
        }, [_createTextVNode(" \"id\" refers to the matter ID. If you have multiple matters with the same ID, any import using that ID will be assigned to the matter created first."), _createElementVNode("br"), _createTextVNode(" Do not use any currency symbols in the Amount column."), _createElementVNode("br")], -1)), _cache[16] || (_cache[16] = _createElementVNode("p", {
          class: "mb-3"
        }, " An example is provided below. ", -1)), _createVNode(_component_v_table, {
          density: "compact",
          class: "selectable-table"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "id"), _createElementVNode("th", null, "Date"), _createElementVNode("th", null, "Description"), _createElementVNode("th", null, "Amount")])], -1), _createElementVNode("tbody", null, [_createElementVNode("tr", null, [_createElementVNode("td", null, "1"), _createElementVNode("td", null, "01/30/21"), _createElementVNode("td", null, "Copying"), _createElementVNode("td", null, "0.85")]), _createElementVNode("tr", null, [_createElementVNode("td", null, "21-0008"), _createElementVNode("td", null, "02/01/21"), _createElementVNode("td", null, "Copying"), _createElementVNode("td", null, "1.7")])], -1)]))]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, !showPreview.value && !wasObjectUploaded.value && !isUploading.value && !loading.value]]), !showPreview.value && wasObjectUploaded.value && !isUploading.value && !loading.value ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "pa-4"
      }, {
        default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("h3", {
          class: "mb-3"
        }, "Expense Data to be Imported", -1)), _createElementVNode("p", _hoisted_6, [_cache[18] || (_cache[18] = _createTextVNode("Below is the raw data to be imported. ", -1)), _withDirectives(_createElementVNode("span", null, [...(_cache[17] || (_cache[17] = [_createTextVNode("Errors are marked in red. ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("b", null, "You cannot import this file until all errors have been resolved.", -1)]))], 512), [[_vShow, validationError.value]]), _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)), _withDirectives(_createElementVNode("span", null, "Scroll down to validate and click NEXT if it looks good.", 512), [[_vShow, !validationError.value]]), _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1))]), _withDirectives(_createVNode(AlertBar, {
          content: validationError.value,
          class: "mb-3"
        }, null, 8, ["content"]), [[_vShow, validationError.value]]), _createVNode(_component_v_table, null, {
          default: _withCtx(() => [_createElementVNode("thead", null, [_createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHeaders(), key => {
            return _openBlock(), _createElementBlock("th", {
              key: key
            }, _toDisplayString(key), 1);
          }), 128))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedObjectArray.value, (row, rowIndex) => {
            return _openBlock(), _createElementBlock("tr", {
              key: rowIndex
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHeaders(), (key, keyIndex) => {
              return _openBlock(), _createElementBlock("td", {
                key: key,
                class: _normalizeClass(getCellClass(row[key], row, keyIndex, key)),
                style: _normalizeStyle(getCellStyle(row[key], row, keyIndex, key))
              }, _toDisplayString(row[key]), 7);
            }), 128))]);
          }), 128))])]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, [_createVNode(LlSecondaryButton, {
          color: "primary",
          disabled: !!validationError.value,
          onClick: _cache[2] || (_cache[2] = $event => next())
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" Next ", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        _: 1
      })) : _createCommentVNode("", true), showPreview.value && !isUploading.value ? (_openBlock(), _createBlock(_component_v_card, {
        key: 1,
        class: "pa-4"
      }, {
        default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("h3", {
          class: "mb-3"
        }, "Expense Import", -1)), _cache[26] || (_cache[26] = _createElementVNode("p", {
          class: "mb-3"
        }, " Below is a preview of each expense that will be saved. ", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(LlCheckbox, {
          modelValue: combine.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => combine.value = $event),
          label: "Combine expenses for the same month",
          onCheckboxClick: _cache[4] || (_cache[4] = $event => combineChanged(combine.value))
        }, null, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_table, null, {
          default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Date"), _createElementVNode("th", null, "Matter"), _createElementVNode("th", null, "Description"), _createElementVNode("th", null, "Amount")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combinedExpenses.value, (row, index) => {
            return _openBlock(), _createElementBlock("tr", {
              key: index
            }, [_createElementVNode("td", null, _toDisplayString(formatDate(row.date)), 1), _createElementVNode("td", null, _toDisplayString(row.matter ? row.matter.label || 'Unknown Matter' : 'No Matter Found'), 1), _createElementVNode("td", null, _toDisplayString(row.description), 1), _createElementVNode("td", null, _toDisplayString(formatAmount(row.amount)), 1)]);
          }), 128))])]),
          _: 1
        }), _createElementVNode("div", _hoisted_9, [_createVNode(LlSecondaryButton, {
          color: "primary",
          onClick: _cache[5] || (_cache[5] = $event => importExpenses())
        }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" Begin import ", -1)]))]),
          _: 1
        })])], 512), [[_vShow, !combining.value]])]),
        _: 1
      })) : _createCommentVNode("", true), isUploading.value ? (_openBlock(), _createBlock(_component_v_card, {
        key: 2,
        class: "pa-4 text-center"
      }, {
        default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("h3", {
          class: "mb-3"
        }, "Importing Expenses", -1)), _cache[29] || (_cache[29] = _createElementVNode("p", {
          class: "mb-4"
        }, [_createTextVNode("To ensure the import completes properly, "), _createElementVNode("strong", null, "do not close this tab or navigate away from this page. ")], -1)), _createVNode(_component_v_progress_linear, {
          "model-value": percentage.value,
          height: "25",
          color: "success",
          class: "mb-2"
        }, {
          default: _withCtx(({
            value
          }) => [_createElementVNode("strong", null, _toDisplayString(Math.round(value)) + "%", 1)]),
          _: 1
        }, 8, ["model-value"]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createVNode(LlSecondaryButton, {
          color: "primary",
          onClick: _cache[6] || (_cache[6] = $event => finish())
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" Done ", -1)]))]),
          _: 1
        }, 512), [[_vShow, !validationError.value && doneImporting.value]])])]),
        _: 1
      })) : _createCommentVNode("", true)])])])) : me.value && me.value.company?.settings?.requireExpenseUser ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[30] || (_cache[30] = [_createElementVNode("h2", null, "Unable to Import", -1), _createElementVNode("h4", null, [_createElementVNode("p", null, "Your firm is currently using the \"Require User on Expenses\" setting. However, users cannot be assigned during an expense import."), _createElementVNode("p", null, "Please disable \"Require User on Expenses\" in the Firm Info settings page and try again.")], -1)]))])) : !me.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[31] || (_cache[31] = [_createElementVNode("h2", null, "Error Loading Page", -1), _createElementVNode("p", null, "Unable to load user information. Please refresh the page and try again.", -1)]))])) : _createCommentVNode("", true);
    };
  }
};